import { IconProps } from './types';

const Tag = ({ color, dimension }: IconProps) => (
  <svg
    fill="none"
    height={dimension || 24}
    viewBox="0 0 24 24"
    width={dimension || 24}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 7.5H7.51M21.09 13.91L13.92 21.08C13.7343 21.266 13.5137 21.4135 13.2709 21.5141C13.0281 21.6148 12.7678 21.6666 12.505 21.6666C12.2422 21.6666 11.9819 21.6148 11.7391 21.5141C11.4963 21.4135 11.2757 21.266 11.09 21.08L2.5 12.5V2.5H12.5L21.09 11.09C21.4625 11.4647 21.6716 11.9716 21.6716 12.5C21.6716 13.0284 21.4625 13.5353 21.09 13.91Z"
      stroke={color || '#101828'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

export default Tag;
